import { Box } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { IPostSearch } from '@/client/legacy-shared-modules/search/search-types';
import { PostContent } from '@/imports/ui/components/search/PostContent';
import { PostContext } from '@/imports/ui/components/search/PostContext';

import { ResultsListContainer } from '../results/ResultsListContainer';
import { getAiAskPostUrl, getPostHitDisplay } from './postDisplayHelpers';

const PostHitContainer: React.FC<{
  hit: IPostSearch;
  children: React.ReactNode;
}> = ({ hit, children }) => (
  <NextLink
    href={getAiAskPostUrl(hit)}
    style={{ textDecoration: 'none' }}
  >
    <Box bg="white" borderRadius="xl" px="5" py="4" cursor="pointer">
      {children}
    </Box>
  </NextLink>
);

const PostHitCard: React.FC<{ hit: IPostSearch }> = ({ hit }) => {
  const { actionLabel, title, bodyAttribute } = getPostHitDisplay(hit);

  return (
    <PostHitContainer hit={hit}>
      <PostContext hit={hit} action={actionLabel} disableHighlight />
      <PostContent
        hit={hit}
        titleAttribute={title}
        bodyAttribute={bodyAttribute}
        disableHighlight
      />
    </PostHitContainer>
  );
};

export const PostsList: React.FC<{
  hits: IPostSearch[];
}> = ({ hits }) => {
  if (hits.length === 0) {
    return null;
  }

  return (
    <ResultsListContainer index="posts">
      {hits.map((postHit) => (
        <PostHitCard key={postHit.objectID} hit={postHit} />
      ))}
    </ResultsListContainer>
  );
};
